var map = {
	"./js/script.js": 38,
	"./sass/styles.scss": 70
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37;


//////////////////
// WEBPACK FOOTER
// ./src/wp-migrate-db-pro-media-files/asset/src ./node_modules/imports-loader?$=>window.jQuery ^(.*\.(js|sass|scss$))/i
// module id = 37
// module chunks = 0